import React from "react";
import Footer from "./Landing/components/Footer";
import styles from "./sass/subpage.module.scss";
import classNames from "classnames";
import { Typography } from "@mui/material";
import Image from "./Landing/assets/misc/impact-investing-3.png";
import Icon1 from "./Landing/assets/misc/icon1.png";
import Icon2 from "./Landing/assets/misc/icon2.png";
import Icon3 from "./Landing/assets/misc/icon3.png";
import Icon4 from "./Landing/assets/misc/icon4.png";
import Icon5 from "./Landing/assets/misc/icon5.png";
import Icon6 from "./Landing/assets/misc/icon6.png";
import ContactForm from "./components/ContactForm";

const ImpactInvesting = (props) => {
  return (
    <>
      <div className={classNames(styles["subpage"], "container")}>
        <div className="row my-5">
          <div className="col-md-8 col-12">
            <Typography variant="h2">OTC Desk</Typography>
            <Typography variant="body1" className={classNames(styles["subheader"], "mt-2")}>
              Bluesphere expands OTC trading options with a range of assets, communication platforms, payment options, and self-custody.
            </Typography>
          </div>
        </div>
        <div className="row mb-5 justify-content-center">
          <div className="col-md-8 col-12">
            <div className={classNames(styles["illustration"], "mb-3")}>
              <img src={Image} alt="An image1"/>
            </div>
            <Typography variant="body1">
              Bluesphere's OTC clients have access to an expanded array of features, including the ability to trade a wider variety of credits and natural capital, such as voluntary and compliance credits, renewable energy credits (RECs), project-based credits, and ReFi digital assets. You can also trade carbon forwards and streaming contracts, and have the option to communicate and execute trades via popular platforms like email, WhatsApp, RCS, iMessage, Skype, Telegram, Slack, Discord, and LinkedIn. With various payment options including wire transfer and cryptocurrency, and the option for self-custody of assets, as well as access to our API, you can customize your trading experience to fit your needs. To start taking advantage of these benefits, please reach out to us to set up direct access to our trading desk.
            </Typography>
            <div className="row my-5">
              <div className={classNames(styles["tile"], "col-4 col-6 text-center mb-5")}>
                <img src={Icon1} className="img-fluid" alt="icon1"/>
                <h4>Trade by email, messaging & phone.</h4>
              </div>
              <div className={classNames(styles["tile"], "col-4 col-6 text-center mb-5")}>
                <img src={Icon2} className="img-fluid" alt="icon2"/>
                <h4>24/7 trade execution</h4>
              </div>
              <div className={classNames(styles["tile"], "col-4 col-6 text-center mb-5")}>
                <img src={Icon3} className="img-fluid" alt="icon2"/>
                <h4>API Access</h4>
              </div>
              <div className={classNames(styles["tile"], "col-4 col-6 text-center mb-5")}>
                <img src={Icon4} className="img-fluid" alt="icon2"/>
                <h4>View & trade project based credits</h4>
              </div>
              <div className={classNames(styles["tile"], "col-4 col-6 text-center mb-5")}>
                <img src={Icon5} className="img-fluid" alt="icon2"/>
                <h4>Wide range of payment options</h4>
              </div>
              <div className={classNames(styles["tile"], "col-4 col-6 text-center mb-5")}>
                <img src={Icon6} className="img-fluid" alt="icon2"/>
                <h4>Self custody</h4>
              </div>
            </div>
            <ContactForm/>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default ImpactInvesting;
